import { Tab } from '../../../../../modals/product/ProductModal';

export default {
  title: 'Nuevo producto',
  tabs: {
    [Tab.General]: 'General',
    [Tab.NutritionInfo]: 'Información nutricional',
  },
  form: {
    categories: {
      label: 'Categorías',
    },
    printer: {
      label: 'Impresora',
    },
    name: {
      label: 'Nombre',
      placeholder: 'Cheeseburger',
    },
    description: {
      label: 'Descripción',
      placeholder: '180g de carne, lechuga, tomates, pepinos, jalapeños y salsa yuppi',
    },
    external_id: {
      label: 'Ref. de {{integration}}',
      placeholder: 'Ej. referencia SKU de HubRise',
      read_only_hint:
        'Editable solo cuando hay una integración HubRise conectada y la sincronización del menú está desactivada.',
    },
    price: {
      label: 'Precio base',
    },
    has_smart_pricing: {
      label: 'Precios especiales para recogida y entrega',
    },
    pickup_price: {
      label: 'Precio de recogida',
      placeholder: 'No especificado',
    },
    delivery_price: {
      label: 'Precio de entrega',
      placeholder: 'No especificado',
    },
    image: {
      label: 'Imagen (opcional)',
    },
    has_combo_tax: {
      label: 'Tiene impuesto combinado',
    },
    is_available: {
      label: 'En stock',
      subtitle: 'Visible en el menú',
    },
    is_visible: {
      label: 'Visible',
      title: 'Visible en el menú',
      subtitle_on: 'Los clientes pueden ver este artículo',
      subtitle_off: 'Oculto para todos los clientes',
    },
    is_available_for_pickup: {
      label: 'Disponible para recogida',
      subtitle_on: 'Los clientes pueden pedir para recoger',
      subtitle_off: 'Oculto del menú de recogida',
    },
    is_available_for_delivery: {
      label: 'Disponible para entrega',
      subtitle_on: 'Los clientes pueden pedir para entrega',
      subtitle_off: 'Oculto del menú de entrega',
    },
    modifiers: {
      label: 'Modificadores',
    },
  },
  labels: {
    smart_pricing_update_warning:
      'Al actualizar, todas las reglas de precios inteligentes existentes para este producto se reescribirán.',
    smart_pricing_remove_warning:
      'Al guardar, todas las reglas de precios inteligentes existentes para este producto se eliminarán.',
  },
  availability: {
    title: 'Disponibilidad',
    helper:
      'La visibilidad es el interruptor principal. Desactiva un canal para ocultar este artículo a los clientes de recogida o entrega sin eliminarlo del menú.',
    status: {
      both: 'Ambos canales',
      pickup_only: 'Solo recogida',
      delivery_only: 'Solo entrega',
      hidden: 'Oculto',
      no_channels: 'Sin canales',
    },
    warning: {
      no_channels: 'Este artículo es visible pero no está disponible en ningún canal: los clientes no podrán pedirlo.',
    },
    placeholder: '—',
    list_badge: {
      pickup_only: 'Solo recogida',
      delivery_only: 'Solo entrega',
      no_channels: 'Sin canales',
    },
  },
  buttons: {
    save: 'Guardar',
    close: 'Cerrar',
  },
  toasts: {
    changes_got_saved: '¡Los cambios se han guardado correctamente!',
  },
};
